import { render, staticRenderFns } from "./ProjectEvidenceDateButton.vue?vue&type=template&id=2fae9950&scoped=true&"
import script from "./ProjectEvidenceDateButton.vue?vue&type=script&lang=js&"
export * from "./ProjectEvidenceDateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae9950",
  null
  
)

export default component.exports